export default __webpack_public_path__ + "static/media/background-email-has-send.63bf9c77.png";